import eventLib from './index';
import { isObject, matchQuery } from '@lhb/func';

/* 操作全局loading的展示与否 */
export function dispatchLoading(data: boolean) {
  eventLib.dispatch('loading', data);
}
/* 触发登录 */
export function dispatchLogin(data: any) {
  eventLib.dispatch('login', data);
}
/* 触发退出登录 */
export function dispatchLogout(some?) {
  if (!some || isObject(some) || typeof some === 'boolean') {
    const data = {
      noHint: false
    };
    typeof some === 'boolean' ? data.noHint = some : Object.assign(data, some);
    eventLib.dispatch('logout', data);
  } else {
    console.log('请输入正确的logout监听参数');
  }
}
/* 触发路由跳转 */
export function dispatchNavigate(path: string | number, extraData?: any) {
  if (matchQuery(location.search, 'source') && String(path).indexOf('source=') === -1) {
    if (String(path).indexOf('?') !== -1) {
      path += `&source=${matchQuery(location.search, 'source')}`;
    } else {
      path += `?source=${matchQuery(location.search, 'source')}`;
    }
  }
  eventLib.dispatch('navigate', path, extraData);
}
